import { api } from '@/api/queries/base';
import { ApiPath } from '@/common/app/api-path';
import {
  type ScratchBuyRequest,
  type ScratchBuyResponse,
  type ScratchEventResponse,
  type ScratchRevealRequest,
  type ScratchRevealResponse,
} from '@/common/types/scratch';

const scratchApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getScratchEvent: builder.query<ScratchEventResponse, void>({
      query: () => ApiPath.SCRATCH_EVENT,
      keepUnusedDataFor: 0,
    }),
    buyScratchTicket: builder.mutation<ScratchBuyResponse, ScratchBuyRequest>({
      query: (body) => ({
        url: ApiPath.SCRATCH_BUY,
        method: 'POST',
        body,
      }),
    }),
    revealScratchTicket: builder.mutation<
      ScratchRevealResponse,
      ScratchRevealRequest
    >({
      query: (body) => ({
        url: ApiPath.SCRATCH_REVEAL,
        method: 'POST',
        body,
      }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetScratchEventQuery,
  useLazyGetScratchEventQuery,
  useBuyScratchTicketMutation,
  useRevealScratchTicketMutation,
} = scratchApi;
